import { Auth } from 'aws-amplify'
import store, { commit, dispatch } from '@/config/store/store'
import {
  FETCH_USER_DATA,
  FetchRoutePermissionsResult,
  GET_USER,
  LoginPayload,
  MODULE_NAME,
  SET_USER,
  SetUserPayload
} from '../types'
import router from '@/config/router/router'
import {
  SHOWCASE_AUTOMATION,
  SHOWCASE_AUTOMATION_PATH
} from '@/domain/showcases/routes/routes'

export const login = async (
  context,
  { username, password }: LoginPayload
): Promise<void> => {
  return Auth.signIn(username, password)
    .then(user => {
      commit<SetUserPayload>(`${MODULE_NAME}/${SET_USER}`, { user: user })
    })
    .catch(err => {
      throw err
    })
}

export const logout = async (): Promise<void> => {
  await Auth.signOut()
    .then(() => {
      commit<SetUserPayload>(`${MODULE_NAME}/${SET_USER}`, { user: null })
    })
    .catch(err => {
      throw err
    })
}

export const checkLoggedIn = async (): Promise<void> => {
  Auth.currentAuthenticatedUser()
    .then(user => {
      if (!store.getters[`${MODULE_NAME}/${GET_USER}`]) {
        router.push('/')
      }
    })
    .catch(() => {})
}

export const fetchUserData = async (): Promise<void> => {
  return Auth.currentAuthenticatedUser()
    .then(user => {
      commit<SetUserPayload>(`${MODULE_NAME}/${SET_USER}`, { user: user })
    })
    .catch()
}

export const fetchRoutePermissions = async (): Promise<FetchRoutePermissionsResult> => {
  return dispatch(`${MODULE_NAME}/${FETCH_USER_DATA}`).then(() => {
    return {
      routes: [
        {
          path: '/',
          name: 'Home'
        },
        {
          path: SHOWCASE_AUTOMATION_PATH,
          name: SHOWCASE_AUTOMATION
        }
      ]
    }
  })
}
